import { useEffect, useRef } from "react";

// On phones, theme.scss turns every <table> into a stack of cards and shows
// each cell's column name next to its value via td::before { content: attr(data-label) }.
// Rather than hand-labelling every cell on every page, copy the <th> text onto
// the matching <td>s whenever the routed content changes.
export default function useTableCardLabels() {
	const ref = useRef(null);

	useEffect(() => {
		const root = ref.current;
		if (!root) return undefined;

		const label = () => {
			root.querySelectorAll("table").forEach((table) => {
				const heads = [...table.querySelectorAll("thead th")].map((th) => th.textContent.trim());
				if (!heads.length) return;
				table.querySelectorAll("tbody tr").forEach((tr) => {
					[...tr.children].forEach((td, i) => {
						const text = heads[i] || "";
						if (td.getAttribute("data-label") !== text) td.setAttribute("data-label", text);
					});
				});
			});
		};

		let frame = 0;
		const observer = new MutationObserver(() => {
			cancelAnimationFrame(frame);
			frame = requestAnimationFrame(label);
		});
		observer.observe(root, { childList: true, subtree: true });
		label();
		return () => {
			observer.disconnect();
			cancelAnimationFrame(frame);
		};
	}, []);

	return ref;
}
